const RETIRED_TYPES = {
  TEAM: 'team',
  COLLEAGUES: 'colleagues'
}

export { RETIRED_TYPES }
